import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS } from "@pnp/common";
export var DirectoryObjectType;
(function (DirectoryObjectType) {
    /**
     * Directory Objects
     */
    DirectoryObjectType[DirectoryObjectType["directoryObject"] = 0] = "directoryObject";
    /**
     * User
     */
    DirectoryObjectType[DirectoryObjectType["user"] = 1] = "user";
    /**
     * Group
     */
    DirectoryObjectType[DirectoryObjectType["group"] = 2] = "group";
    /**
     * Device
     */
    DirectoryObjectType[DirectoryObjectType["device"] = 3] = "device";
})(DirectoryObjectType || (DirectoryObjectType = {}));
/**
 * Describes a collection of Directory Objects
 *
 */
var DirectoryObjects = /** @class */ (function (_super) {
    tslib_1.__extends(DirectoryObjects, _super);
    function DirectoryObjects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DirectoryObjects_1 = DirectoryObjects;
    /**
     * Gets a directoryObject from the collection using the specified id
     *
     * @param id Id of the Directory Object to get from this collection
     */
    DirectoryObjects.prototype.getById = function (id) {
        return new DirectoryObject(this, id);
    };
    /**
    * Returns the directory objects specified in a list of ids. NOTE: The directory objects returned are the full objects containing all their properties.
    * The $select query option is not available for this operation.
    *
    * @param ids A collection of ids for which to return objects. You can specify up to 1000 ids.
    * @param type A collection of resource types that specifies the set of resource collections to search. Default is directoryObject.
    */
    DirectoryObjects.prototype.getByIds = function (ids, type) {
        if (type === void 0) { type = DirectoryObjectType.directoryObject; }
        return this.clone(DirectoryObjects_1, "getByIds").postCore({
            body: jsS({
                ids: ids,
                type: type,
            }),
        });
    };
    var DirectoryObjects_1;
    DirectoryObjects = DirectoryObjects_1 = tslib_1.__decorate([
        defaultPath("directoryObjects")
    ], DirectoryObjects);
    return DirectoryObjects;
}(GraphQueryableCollection));
export { DirectoryObjects };
/**
 * Represents a Directory Object entity
 */
var DirectoryObject = /** @class */ (function (_super) {
    tslib_1.__extends(DirectoryObject, _super);
    function DirectoryObject() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes this group
     */
    DirectoryObject.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Returns all the groups and directory roles that the specified Directory Object is a member of. The check is transitive
     *
     * @param securityEnabledOnly
     */
    DirectoryObject.prototype.getMemberObjects = function (securityEnabledOnly) {
        if (securityEnabledOnly === void 0) { securityEnabledOnly = false; }
        return this.clone(DirectoryObject, "getMemberObjects").postCore({
            body: jsS({
                securityEnabledOnly: securityEnabledOnly,
            }),
        });
    };
    /**
     * Returns all the groups that the specified Directory Object is a member of. The check is transitive
     *
     * @param securityEnabledOnly
     */
    DirectoryObject.prototype.getMemberGroups = function (securityEnabledOnly) {
        if (securityEnabledOnly === void 0) { securityEnabledOnly = false; }
        return this.clone(DirectoryObject, "getMemberGroups").postCore({
            body: jsS({
                securityEnabledOnly: securityEnabledOnly,
            }),
        });
    };
    /**
     * Check for membership in a specified list of groups, and returns from that list those groups of which the specified user, group, or directory object is a member.
     * This function is transitive.
     * @param groupIds A collection that contains the object IDs of the groups in which to check membership. Up to 20 groups may be specified.
     */
    DirectoryObject.prototype.checkMemberGroups = function (groupIds) {
        return this.clone(DirectoryObject, "checkMemberGroups").postCore({
            body: jsS({
                groupIds: groupIds,
            }),
        });
    };
    return DirectoryObject;
}(GraphQueryableInstance));
export { DirectoryObject };
//# sourceMappingURL=directoryobjects.js.map